// removed by extract-text-webpack-plugin
module.exports = {"page":"page__3oCcC","content_wrapper":"content_wrapper__3f8v9","content":"content__2KO8w"};


//////////////////
// WEBPACK FOOTER
// ./components/app.scss
// module id = Wjq/
// module chunks = 13